(() => {
  class ProductPoints extends HTMLElement {
    static observedAttributes = ["amount", "icon"];

    constructor() {
      super();
      this.attachShadow({ mode: "open" });
    }

    connectedCallback() {
      const { content, pointsPercentage, pointsPerDollar } =
        window.productPoints;

      this.content = content;
      this.pointsPercentage = pointsPercentage;
      this.pointsPerDollar = pointsPerDollar;
      this.price = this.getAttribute("amount");
      this.icon = this.getAttribute("icon");
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === "amount" && oldValue !== newValue) {
        this.price = newValue;
      }
      if (name === "icon" && oldValue !== newValue) {
        this.icon = newValue;
      }
    }

    set price(value) {
      this._price = Number(value) / 100;
      this.render();
    }

    get price() {
      return this._price;
    }

    get points() {
      return Math.round((this.price * this.pointsPercentage) / 100);
    }

    get amountReceived() {
      return this.points / this.pointsPerDollar;
    }

    get dollars() {
      const locale =
        `${Shopify.locale}${Shopify.country ? `-${Shopify.country}` : ""}` ||
        "en-US";

      return Intl.NumberFormat(locale, {
        style: "currency",
        currency: Shopify.currency.active,
      }).format(this.amountReceived);
    }

    render() {
      if (!this.content) return;

      this.shadowRoot.innerHTML = `
        <style>
          .product-points {
            background: var(--color-brand);
            margin: 0;
            padding: 8px 12px;
            display: flex;
            align-items: center;
            gap: 4px;

            p {
              margin: 0;
            }

            strong {
              font-weight: 600;
            }

            a {
              color: black;
            }
          }
        </style>
        
        <div class="product-points">
          ${this.icon ? `<img src="${this.icon}" alt="Points icon" width="16" height="16">` : ""}
          <span class="product-points__content">
            ${this.content.replace("[points]", this.points).replace("[dollars]", this.dollars)}
          </span>
        </div>
      `;
    }
  }

  customElements.define("product-points", ProductPoints);
})();
